import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=bd4740d8&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"
import style0 from "./CreatePassword.vue?vue&type=style&index=0&id=bd4740d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4740d8",
  null
  
)

export default component.exports